var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6192 0C12.6622 0 13.6656 0.412222 14.4037 1.15189C15.1426 1.89 15.5556 2.88556 15.5556 3.92778V10.0722C15.5556 12.2422 13.79 14 11.6192 14H3.93556C1.76478 14 0 12.2422 0 10.0722V3.92778C0 1.75778 1.757 0 3.93556 0H11.6192ZM12.4989 4.04444C12.3356 4.03589 12.18 4.09111 12.0626 4.2L8.55556 7C8.10444 7.37411 7.45811 7.37411 7 7L3.5 4.2C3.25811 4.02111 2.92367 4.04444 2.72222 4.25444C2.51222 4.46444 2.48889 4.79889 2.667 5.03222L2.76889 5.13333L6.30778 7.89444C6.74333 8.23667 7.27144 8.42333 7.82444 8.42333C8.37589 8.42333 8.91333 8.23667 9.34811 7.89444L12.8567 5.08667L12.9189 5.02444C13.1048 4.79889 13.1048 4.47222 12.9103 4.24667C12.8022 4.13078 12.6537 4.06 12.4989 4.04444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.2bef6120743fe7ec49bb1c0454eefea9.svg";
export { ForwardRef as ReactComponent };